// removed by extract-text-webpack-plugin
module.exports = {"link":"style__link___3Kt3N"};


//////////////////
// WEBPACK FOOTER
// ./components/PageLink/style.scss
// module id = 1125
// module chunks = 0